<template>
  <v-app id="app">
    <v-navigation-drawer v-if="authService.loggedIn()" class="hidden-md-and-up"
      v-model="drawerLeft"
      left
      app
      clipped
      disable-resize-watcher
      >
      <v-list>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar size=22>
              <v-icon color="grey" small>view_list</v-icon>
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <a :href="`/projects/${currentProjectId}`">
                All tickets
              </a>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-action>
            <v-avatar size=22>
              <v-icon color="grey" small>access_time</v-icon>
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <a :href="`/projects/${currentProjectId}/backlog`">
                Backlog
              </a>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-action>
            <v-avatar size=22>
              <v-icon>visibility</v-icon>
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <a href="/watches">
                Activity
              </a>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-action>
            <v-avatar size=22>
              <v-icon>email</v-icon>
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <a :href="`/projects/${currentProjectId}/emails`">
                Emails
              </a>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar v-if="authService.loggedIn()"
      color="primary"
      dark
      fixed
      app
      clipped-right
      >
      <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="drawerLeft = !drawerLeft"></v-toolbar-side-icon>

      <v-toolbar-title>
        <a href="/">
          <img src="@/assets/cicon.png" class="pt-2">
        </a>
      </v-toolbar-title>

      <v-toolbar-title class="ml-0">
        <a href="/" class="white--text">
          Conductor
        </a>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-flex xs3 class="hidden-md-and-down" v-if="currentProjectId">
        <v-menu
          offset-y
          nudge-bottom="10"
          nudge-left="10"
          >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="searchQuery"
              append-icon="search"
              label="Find a ticket"
              v-on="on"
              solo
              light
            ></v-text-field>
          </template>

          <v-list>
            <v-list-tile v-show="searchResults.length === 0">
              <v-list-tile-title>
                No matches...
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-for="(item, index) in searchResults"
              :key="index"
              >
              <v-list-tile-title>
                <a :href="`/projects/${currentProjectId}/tickets/${item.sequential_id}`" :target="`con${item.sequential_id}`">
                  <v-chip label outline dark small>
                    # {{item.sequential_id}}
                  </v-chip>
                  {{ item.title }}
                </a>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

      <v-menu offset-y v-show="projects.length > 0" class="hidden-sm-and-down mr-3 ml-5">
        <v-toolbar-title slot="activator" app >
          <v-avatar size=36 v-if="currentProject">
            <img :src="projectLogoThumbUrl(currentProject)" alt="Avatar" v-if="projectLogoThumbUrl(currentProject)">
            <v-icon color="primary" v-else>ballot</v-icon>
          </v-avatar>
          {{currentProject && currentProject.attributes.name || 'Projects'}}
          <v-icon v-show="projects.length > 0">arrow_drop_down</v-icon>
        </v-toolbar-title>
        <v-list>
          <v-list-tile>
            <v-list-tile-title>
              <a :href="`/projects`">
                <v-avatar size=22>
                  <v-icon color="grey" small>ballot</v-icon>
                </v-avatar>
                All Projects
              </a>
            </v-list-tile-title>
          </v-list-tile>
          <hr v-if="projects.filter(prj => prj.id != currentProjectId).length > 0">
          <v-list-tile
            v-for="prj in projects.filter(prj => prj.id != currentProjectId)"
            :key="prj.id"
            >
            <v-list-tile-title>
              <a :href="`/projects/${prj.id}`">
                <v-avatar size=22>
                  <img :src="projectLogoThumbUrl(prj)" alt="Avatar" v-if="projectLogoThumbUrl(prj)">
                  <v-icon color="grey" small v-else>ballot</v-icon>
                </v-avatar>
                {{prj.attributes.name}}
              </a>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-menu offset-y v-show="boards.length > 0" class="hidden-sm-and-down">
        <v-toolbar-title slot="activator">
          <v-icon>view_carousel</v-icon>
          <span>{{currentBoard && currentBoard.attributes.name || 'Boards'}}</span>
          <v-icon v-show="boards.length > 0">arrow_drop_down</v-icon>
        </v-toolbar-title>
        <v-list>
          <v-list-tile>
            <v-list-tile-title>
              <a :href="`/projects/${currentProjectId}`">
                <v-avatar size=22>
                  <v-icon color="grey" small>view_list</v-icon>
                </v-avatar>
                All tickets
              </a>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>
              <a :href="`/projects/${currentProjectId}/backlog`">
                <v-avatar size=22>
                  <v-icon color="grey" small>access_time</v-icon>
                </v-avatar>
                Backlog
              </a>
            </v-list-tile-title>
          </v-list-tile>
          <hr v-if="boards.filter(brd => brd.id != currentBoardId).length > 0">
          <v-list-tile
            v-for="brd in sortedBoards.filter(brd => brd.id != currentBoardId)"
            :key="brd.id"
            >
            <v-list-tile-title>
              <a :href="`/boards/${brd.id}`">
                <v-avatar size=22>
                  <v-icon color="grey" small>dashboard</v-icon>
                </v-avatar>
                {{brd.attributes.name}}
              </a>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-toolbar-title v-if="false">
        <v-icon>bar_chart</v-icon>
        <span class="hidden-sm-and-down">Analytics</span>
      </v-toolbar-title>

      <v-toolbar-title v-show="projects.length > 0" class="hidden-sm-and-down">
        <a href="/watches" class="white--text">
          <v-icon>visibility</v-icon>
          Activity
        </a>
      </v-toolbar-title>

      <v-toolbar-title v-show="currentProject" class="hidden-sm-and-down">
        <a :href="`/projects/${currentProjectId}/emails`" class="white--text">
          <v-icon>email</v-icon>
          Emails
        </a>
      </v-toolbar-title>

      <v-toolbar-title @click.stop="drawerRight = !drawerRight">
        <v-avatar size=36>
          <img :src="userAvatarUrl" v-if="userAvatarUrl">
          <v-icon color="primary" v-else>person_outline</v-icon>
        </v-avatar>
        <v-icon>more_vert</v-icon>
      </v-toolbar-title>
    </v-toolbar>

    <v-toolbar v-if="accessingShare"
      color="primary"
      dark
      fixed
      app
      clipped-right
      >
      <v-toolbar-title>
        <a href="/">
          <img src="@/assets/cicon.png" class="pt-2">
        </a>
      </v-toolbar-title>

      <v-toolbar-title class="ml-0">
        <a href="/" class="white--text">
          Conductor
        </a>
      </v-toolbar-title>
    </v-toolbar>

    <v-navigation-drawer v-if="authService.loggedIn()"
      v-model="drawerRight"
      fixed
      right
      clipped
      app
      disable-resize-watcher
      >
      <v-list dense>
        <v-list-tile href="/profile">
          <v-list-tile-action>
            <v-icon>person</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>My Profile</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile href="/preference">
          <v-list-tile-action>
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Preferences</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile href="/password">
          <v-list-tile-action>
            <v-icon>lock</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Password</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile :href="`/projects/${currentProjectId}/purchases`" v-if="currentProject && permit.canCreatePurchase(currentProject)">
          <v-list-tile-action>
            <v-icon>wallet</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Subscription</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <hr>

        <v-list-tile href="/jargon/policy">
          <v-list-tile-action>
            <v-icon>policy</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Policies</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile href="/jargon/contact">
          <v-list-tile-action>
            <v-icon>contact_support</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Contact us</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <hr>
        <v-list-tile @click="authService.logout()" href="/">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sign out</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content :class="backgroundClass()">
      <v-container fluid fill-height grid-list-md >
        <v-layout>
          <v-flex>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-footer color="white--text primary" app>
      <span class="text-capitalize caption pl-3">Intuitive Task Delivery</span>
      <v-spacer></v-spacer>
      <span class="pr-3 caption">made by Elarex</span>
    </v-footer>
  </v-app>
</template>

<script>
  import { debounce } from 'debounce'
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'
  import permissions from '@/utilities/permissions'

  import authService from '@/services/authentication'
  import userService from '@/services/user'
  import projectService from '@/services/project'
  import boardService from '@/services/board'
  import ticketService from '@/services/ticket'

  export default {
    name: 'app',

    data () {
      return {
        auth: authentication,
        authService: authService,
        permit: permissions,
        drawerLeft: false,
        drawerRight: false,
        user: null,
        projects: [],
        currentProjectId: null,
        boards: [],
        currentBoardId: null,
        searchQuery: null,
        searchResults: []
      }
    },

    watch: {
      searchQuery (val) {
        if (val) {
          this.searchForTicket(val)
        } else {
          this.searchResults = []
        }
      }
    },

    mounted () {
      if (this.accessingShare) {
        // we are accessing a share and we are not a user
      } else {
        // we are logged in as a user
        EventBus.$on('project-context', this.changeProjectContext)
        EventBus.$on('board-context', this.changeBoardContext)
        EventBus.$on('board-created', this.reloadBoards)

        // this is for if we just logged in
        EventBus.$on('authenticated', this.loadUser)
        EventBus.$on('authenticated', this.loadProjects)
        // this is if we are logged in an refresh the page
        this.loadUser()
        this.loadProjects()

        if (this.$route.params['boardId']) {
          boardService.show(
            (data) => {
              this.currentBoardId = data.id
              this.changeProjectContext(data.relationships.project.data.id)
            },
            (err) => {
              console.log(err)
            },
            this.$route.params['boardId']
          )
        } else if (this.$route.params['projectId']) {
          this.changeProjectContext(this.$route.params['projectId'])
        }
      }
    },

    computed: {
      currentProject () {
        return this.projects.find(prj => prj.id == this.currentProjectId)
      },

      currentBoard () {
        return this.boards.find(brd => parseInt(brd.id) == parseInt(this.currentBoardId))
      },

      userAvatarUrl () {
        if (this.user && this.user.links && this.user.links.avatar_uri) {
          return (process.env.API_URL + this.user.links.avatar_uri)
        }
        return null
      },

      sortedBoards () {
        return this.boards.sort((a, b) => { return a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase()) })
      },

      accessingShare () {
        return (this.$route.name === 'shares')
      }
    },

    methods: {
      loadUser () {
        if (authService.loggedIn()) {
          userService.show(
            (data) => {
              this.user = Object.assign({}, data)
            },
            (err) => {
              console.log(err)
            },
           this.auth.userId()
          )
        }
      },

      loadProjects () {
        if (authService.loggedIn()) {
          projectService.index(
            (data) => {
              this.projects = data
            },
            (err) => {
              console.log(err)
            }
          )
        }
      },

      // respond to project being loaded elsewhere, we should only have one active at a time
      changeProjectContext (projectId) {
        if (projectId) {
          this.currentProjectId = projectId
          this.loadBoards()
        } else {
          this.currentProjectId = null
          this.boards = []
        }
      },

      loadBoards () {
        boardService.projectIndex(
          (data) => {
            this.boards = data.filter(brd => !brd.attributes.archived)
            this.boards.sort((a, b) => { return a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase()) })
          },
          (err) => {
            console.log(err)
          },
          this.currentProjectId
        )
      },

      reloadBoards () {
        this.loadBoards()
      },

      // respond to board being loaded elsewhere, we should only have one active at a time
      changeBoardContext (boardId) {
        this.currentBoardId = boardId
      },

      // change screen background on login/log out
      backgroundClass () {
        if (authService.loggedIn()) {
          return 'logged-in-background'
        } else if (this.accessingShare) {
          return 'shares-background'
        } else {
          return 'logged-out-background'
        }
      },

      searchForTicket: debounce(function (query) {
        ticketService.projectIndex(
          (data) => {
            this.searchResults = data.map((t) => t.attributes)
          },
          (err) => {
            console.log(err)
          },
          this.currentProjectId, {search: this.searchQuery, rowsPerPage: 5, sortBy: 'title', page: 1}, false
        )
      }, 500),

      projectLogoThumbUrl (project) {
        if (project && project.links && project.links.logo_thumb_uri) {
          return (process.env.API_URL + project.links.logo_thumb_uri)
        } else {
          return null
        }
      }
    }
  }
</script>

<style lang="scss">
  @import './assets/stylesheets/global.scss';

  .logged-in-background {
    background: #f7f5f4;
  }

  .shares-background {
    background: #f7f5f4;
  }

  .logged-out-background {
    background: url('./assets/loggedout.jpg') no-repeat center;
    background-size: cover;
  }

  .v-list__tile__title {
    height: 32px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue